import { coalesceIdenticalRequests } from '../../../api/coalesceIdenticalRequests';
import { transformParams } from '../../../api/serializers';
import { ServiceHandler } from '../../../utils';
import { utcISO } from '../../../utils/date.utils';

function serializeDates({ createdDate, effectiveDate, ...params }: any) {
  return {
    ...params,
    createdDate: utcISO(createdDate),
    effectiveDate: utcISO(effectiveDate),
  };
}

const patchQuoteHandler = ServiceHandler({
  url: '/api/quote/v1/:id',
  method: 'put',
});
export const patchQuote = ({ id }: { id: string | number }, data?: unknown) =>
  patchQuoteHandler(id, { data });

const declineQuoteHandler = ServiceHandler({
  url: '/api/quote/v1/decline/:id',
  method: 'put',
});
export const declineQuote = ({ id }: { id: string | number }, data?: unknown) =>
  declineQuoteHandler(id, { data });

const lostQuoteHandler = ServiceHandler({
  url: '/api/quote/v1/lost/:id',
  method: 'put',
});
export const lostQuote = ({ id }: { id: string | number }, data?: unknown) =>
  lostQuoteHandler(id, { data });

const updateNeedByHandler = ServiceHandler({
  url: '/api/quote/v1/update/needBy?quoteId=:id&needBy=:date',
  method: 'put',
});
export const updateNeedBy = ({
  id,
  date,
}: {
  id: string | number;
  date: string;
}) => updateNeedByHandler(id, date);

/**
 * @param limit
 * @param revenue
 * @param createdDate optional
 */
const getCarrierProfilesHandler = ServiceHandler({
  url: '/api/rater/v1/carrier/profiles',
  paramsSerializer: transformParams([serializeDates]),
});
/*
 * The underwriter P250 view asked for the same carrier list from its dropdown and again before
 * every recalculation, about 3.9 times per page load in US prod on 2026-11-04. Identical requests
 * now share one result for 60s.
 */
const getCarrierProfilesCoalesced = coalesceIdenticalRequests(
  (params: Record<string, unknown>) => getCarrierProfilesHandler({ params }),
  { reuseMs: 60_000 }
);
export const getCarrierProfiles = (params: Record<string, unknown> = {}) =>
  getCarrierProfilesCoalesced(params);
